// Angular
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { APP_INITIALIZER, enableProdMode, ErrorHandler, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, withExperimentalAutoCleanupInjectors, withRouterConfig } from '@angular/router';

// RxJS
import { Observable } from 'rxjs';

// Third-party
import { provideOAuthClient } from 'angular-oauth2-oidc';

// Component Library
import { FsxErrorHandler, provideFsxComponentLibrary, setupFsxChunkLoadErrorReload } from 'fsx-component-library';

// Local
import { AppComponent, loadConfig } from './app/app.component';
import { AppConfig, ENV_CONFIG } from './app/core/app-config/app-config.service';
import { FSXInterceptor } from './app/core/fsx.interceptor';
import { provideAppChangeDetection } from './app/core/provide-app-change-detection';
import { provideWindow } from './app/core/window.factory';
import { EnvConfig } from './app/types/environments';
import { environment } from './environments/environment';
import { APP_ROUTES } from './routes';

// Enable production mode if the environment is production
if (environment.production) {
  enableProdMode();
}

// Setup chunk load error reload to handle chunk load errors
setupFsxChunkLoadErrorReload();

bootstrapApplication(AppComponent, {
  providers: [
    provideAppChangeDetection(environment),
    { provide: ErrorHandler, useClass: FsxErrorHandler },
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: FSXInterceptor, multi: true },
    provideWindow(),
    {
      provide: ENV_CONFIG,
      useFactory: (appConfig: AppConfig): Observable<EnvConfig> =>
        appConfig.envConfig,
      deps: [AppConfig],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: loadConfig,
      deps: [AppConfig],
      multi: true,
    },
    provideOAuthClient(),
    provideRouter(
      APP_ROUTES,
      withRouterConfig({ paramsInheritanceStrategy: 'emptyOnly' }),
      withExperimentalAutoCleanupInjectors()
    ),
    importProvidersFrom(BrowserAnimationsModule),
    provideFsxComponentLibrary(),
  ],
}).catch(err => console.error('Error occurred in bootstrapApplication:', err));
